export type EnteredByLabel = {
	label: string;
	isSystem: boolean;
};

// SMC3 visibility updates arrive as "Visibility Services - SMC3".
const API_PATTERN = /smc3|visibility[\s_]services/i;
// RPA bots post under service accounts such as "SvcRpaOmass1_P".
const RPA_PATTERN = /^svc_?rpa/i;

export const getEnteredByLabel = (
	enteredBy: string | null | undefined,
): EnteredByLabel | null => {
	const value = enteredBy?.trim();
	if (!value) return null;
	if (API_PATTERN.test(value)) return { label: "API", isSystem: true };
	if (RPA_PATTERN.test(value)) return { label: "RPA", isSystem: true };
	return { label: value, isSystem: false };
};
